import React, { useMemo } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

type TagsProps = {
  tags: string[];
};

const Tags = ({ tags }: TagsProps): JSX.Element => {
  const { t } = useTranslation();

  const tagsData = useMemo(() => {
    return {
      ux: {
        title: t('tagUX'),
        bg: 'bg-primaryLighter',
      },
      training: {
        title: t('tagTraining'),
        bg: 'bg-primaryLighter',
      },
      designThinking: {
        title: t('tagDesignThinking'),
        bg: 'bg-primaryLighter',
      },
      growth: {
        title: t('tagGrowth'),
        bg: 'bg-orange',
      },
      data: {
        title: t('tagData'),
        bg: 'bg-green',
      },
      development: {
        title: t('tagDevelopment'),
        bg: 'bg-yellow',
      },
      rn: {
        title: t('tagRN'),
        bg: 'bg-yellow',
      },
      api: {
        title: t('tagAPI'),
        bg: 'bg-yellow',
      },
      refacto: {
        title: t('tagRefacto'),
        bg: 'bg-primaryLighter',
      },
      proto: {
        title: t('tagProto'),
        bg: 'bg-primaryLighter',
      },
      front: {
        title: t('tagFront'),
        bg: 'bg-yellow',
      },
      saas: {
        title: t('tagSaaS'),
        bg: 'bg-yellow',
      },
      react: {
        title: t('tagReact'),
        bg: 'bg-yellow',
      },
      storybook: {
        title: t('tagStorybook'),
        bg: 'bg-yellow',
      },
      tailwind: {
        title: t('tagTailwind'),
        bg: 'bg-yellow',
      },
      js: {
        title: t('tagJS'),
        bg: 'bg-yellow',
      },
      css: {
        title: t('tagCSS'),
        bg: 'bg-yellow',
      },
      growthHacking: {
        title: t('tagGrowth'),
        bg: 'bg-orange',
      },
      acquisition: {
        title: t('tagAcquisition'),
        bg: 'bg-orange',
      },
      prospection: {
        title: t('tagProspection'),
        bg: 'bg-orange',
      },
      linkedin: {
        title: t('tagLinkedin'),
        bg: 'bg-orange',
      },
      emailScraping: {
        title: t('tagEmailScraping'),
        bg: 'bg-orange',
      },
      dataEnhancement: {
        title: t('tagDataEnhancement'),
        bg: 'bg-orange',
      },
      mobile: {
        title: t('tagMobile'),
        bg: 'bg-yellow',
      },
      rails: {
        title: t('tagRails'),
        bg: 'bg-yellow',
      },
      aso: {
        title: t('tagASO'),
        bg: 'bg-orange',
      },
      etl: {
        title: t('tagETL'),
        bg: 'bg-green',
      },
      grafana: {
        title: t('tagGrafana'),
        bg: 'bg-green',
      },
      dataViz: {
        title: t('tagDataViz'),
        bg: 'bg-green',
      },
      python: {
        title: t('tagPython'),
        bg: 'bg-green',
      },
      docker: {
        title: t('tagDocker'),
        bg: 'bg-green',
      },
      postgres: {
        title: t('tagPostgres'),
        bg: 'bg-green',
      },
      internal: {
        title: t('tagInternal'),
        bg: 'bg-internal',
      },
      notion: {
        title: t('tagNotion'),
        bg: 'bg-orange',
      },
      seo: {
        title: t('tagSeo'),
        bg: 'bg-orange',
      },
      startup: {
        title: t('tagStartup'),
        bg: 'bg-lightBlue',
      },
      googleDataStudio: {
        title: t('tagGoogleDataStudio'),
        bg: 'bg-green',
      },
      intrapreunariat: {
        title: t('tagIntrapreunariat'),
        bg: 'bg-green',
      },
      print: {
        title: t('tagPrint'),
        bg: 'bg-orange',
      },
    };
  }, [t]);

  return (
    <>
      {tags.map((tagItem) => (
        <div
          key={tagItem}
          className={classNames(
            'py-1.5 px-2.5 inline-block rounded mr-2 mb-2 text-mainDark',
            'hover:-translate-y-[3%] transition-all duration-500',
            tagsData[tagItem].bg,
          )}
        >
          {tagsData[tagItem].title}
        </div>
      ))}
    </>
  );
};

export default Tags;
